import React, { useEffect, useMemo, useState } from "react";
import ConfirmModal from "../utils/ConfirmModal";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useAuthFetch } from "../hooks/useAuthFetch";
import "../stili/RisultatoGara.css";

const API_URL = process.env.REACT_APP_API_URL;

const TIPI_RETE = [
  { value: "NORMALE", label: "Normale" },
  { value: "RIGORE", label: "Rigore" },
  { value: "AUTOGOL", label: "Autogol" },
];

export default function RisultatoGara() {
  const navigate = useNavigate();
  const authFetch = useAuthFetch();

  const [eventi, setEventi] = useState([]);
  const [selectedEventoId, setSelectedEventoId] = useState("");
  const [categorie, setCategorie] = useState([]);
  const [selectedCategoria, setSelectedCategoria] = useState("");
  const [gare, setGare] = useState([]);
  const [selectedGaraId, setSelectedGaraId] = useState("");
  const [giocatori, setGiocatori] = useState([]);

  const [osservazioniGara, setOsservazioniGara] = useState("");
  const [visibileBacheca, setVisibileBacheca] = useState(false);

  const [risultatoEsistenteId, setRisultatoEsistenteId] = useState(null);
  const [reti, setReti] = useState([]);

  const [marcatoreSelezionato, setMarcatoreSelezionato] = useState(null);
  const [assistSelezionato, setAssistSelezionato] = useState(null);
  const [minuto, setMinuto] = useState("");
  const [tipoRete, setTipoRete] = useState("NORMALE");
  const [squadraRete, setSquadraRete] = useState("MONTEROTONDO");
  const [reteInModificaId, setReteInModificaId] = useState(null);

  const [showFineGara, setShowFineGara] = useState(false);
  const [garaChiusa, setGaraChiusa] = useState(false);

  const [loadingEventi, setLoadingEventi] = useState(false);
  const [loadingCategorie, setLoadingCategorie] = useState(false);
  const [loadingGare, setLoadingGare] = useState(false);
  const [loadingGiocatori, setLoadingGiocatori] = useState(false);
  const [loadingRisultato, setLoadingRisultato] = useState(false);
  const [loadingReti, setLoadingReti] = useState(false);
  const [savingRisultato, setSavingRisultato] = useState(false);
  const [savingRete, setSavingRete] = useState(false);
  const [deletingReteId, setDeletingReteId] = useState(null);
  const [reteDaEliminare, setReteDaEliminare] = useState(null);

  const getGaraId = (g) => g?.idGara ?? g?.id ?? null;

  const getRisultatoId = (r) =>
    r?.id ?? r?.idRisultatoGara ?? r?.id_risultato_gara ?? null;

  const eventoSelezionato = useMemo(
    () => eventi.find((e) => String(e.id) === String(selectedEventoId)) || null,
    [eventi, selectedEventoId]
  );

  const categoriaSelezionataObj = useMemo(
    () => categorie.find((c) => String(c.id) === String(selectedCategoria)) || null,
    [categorie, selectedCategoria]
  );

  const garaSelezionata = useMemo(
    () => gare.find((g) => String(getGaraId(g)) === String(selectedGaraId)) || null,
    [gare, selectedGaraId]
  );

  const squadraCasaLabel = useMemo(() => {
    const avversario = garaSelezionata?.avversario || "Avversario";
    const luogo = garaSelezionata?.luogo;
    if (luogo === "TRASFERTA") return avversario;
    return "Monterotondo 1935";
  }, [garaSelezionata]);

  const squadraOspiteLabel = useMemo(() => {
    const avversario = garaSelezionata?.avversario || "Avversario";
    const luogo = garaSelezionata?.luogo;
    if (luogo === "TRASFERTA") return "Monterotondo 1935";
    return avversario;
  }, [garaSelezionata]);

  const nomeSquadraRete = useMemo(() => {
    if (squadraRete === "AVVERSARIA") {
      return garaSelezionata?.avversario || "Squadra avversaria";
    }
    return "Monterotondo 1935";
  }, [squadraRete, garaSelezionata]);

  const punteggio = useMemo(() => {
    let monterotondo = 0;
    let avversaria = 0;

    reti.forEach((r) => {
      if (r?.squadraRete === "AVVERSARIA") {
        avversaria += 1;
      } else {
        monterotondo += 1;
      }
    });

    const luogo = garaSelezionata?.luogo;

    if (luogo === "TRASFERTA") {
      return {
        goalCasa: avversaria,
        goalOspite: monterotondo,
      };
    }

    return {
      goalCasa: monterotondo,
      goalOspite: avversaria,
    };
  }, [reti, garaSelezionata]);

  const resetRisultatoAndReti = () => {
    setOsservazioniGara("");
    setVisibileBacheca(false);
    setRisultatoEsistenteId(null);
    setReti([]);
    setMarcatoreSelezionato(null);
    setAssistSelezionato(null);
    setMinuto("");
    setTipoRete("NORMALE");
    setSquadraRete("MONTEROTONDO");
    setReteInModificaId(null);
    setShowFineGara(false);
    setGaraChiusa(false);
  };

  const resetReteForm = () => {
    setMarcatoreSelezionato(null);
    setAssistSelezionato(null);
    setMinuto("");
    setTipoRete("NORMALE");
    setSquadraRete("MONTEROTONDO");
    setReteInModificaId(null);
  };

  useEffect(() => {
    if (squadraRete === "AVVERSARIA") {
      setMarcatoreSelezionato(null);
      setAssistSelezionato(null);
    }
  }, [squadraRete]);

  useEffect(() => {
    if (tipoRete === "AUTOGOL") {
      setAssistSelezionato(null);
    }
  }, [tipoRete]);

  useEffect(() => {
    const fetchEventi = async () => {
      setLoadingEventi(true);
      try {
        const res = await authFetch(`${API_URL}/api/eventi-gara`);
        if (!res.ok) throw new Error("Errore eventi");
        const data = await res.json().catch(() => []);
        setEventi(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error(error);
        toast.error("Impossibile caricare gli eventi gara.");
        setEventi([]);
      } finally {
        setLoadingEventi(false);
      }
    };

    fetchEventi();
  }, [authFetch]);

  useEffect(() => {
    const fetchCategorie = async () => {
      if (!selectedEventoId) {
        setCategorie([]);
        setSelectedCategoria("");
        setSelectedGaraId("");
        setGare([]);
        setGiocatori([]);
        resetRisultatoAndReti();
        return;
      }

      setLoadingCategorie(true);
      try {
        const res = await authFetch(
          `${API_URL}/api/gare/evento/${selectedEventoId}/mie-categorie`
        );

        if (!res.ok) throw new Error("Errore categorie");

        const data = await res.json().catch(() => []);
        const lista = Array.isArray(data) ? data : [];

        setCategorie(lista);
        setSelectedGaraId("");
        setGare([]);
        setGiocatori([]);
        resetRisultatoAndReti();

        if (lista.length === 1) {
          setSelectedCategoria(String(lista[0].id));
        } else {
          setSelectedCategoria("");
        }
      } catch (error) {
        console.error(error);
        setCategorie([]);
        setSelectedCategoria("");
        setSelectedGaraId("");
        setGare([]);
        setGiocatori([]);
        resetRisultatoAndReti();
        toast.error("Impossibile caricare le categorie.");
      } finally {
        setLoadingCategorie(false);
      }
    };

    fetchCategorie();
  }, [selectedEventoId, authFetch]);

  useEffect(() => {
    const fetchGare = async () => {
      if (!selectedEventoId || !selectedCategoria) {
        setGare([]);
        setSelectedGaraId("");
        setGiocatori([]);
        resetRisultatoAndReti();
        return;
      }

      setLoadingGare(true);
      try {
        const res = await authFetch(
          `${API_URL}/api/gare/evento/${selectedEventoId}/categoria/${selectedCategoria}`
        );

        if (!res.ok) throw new Error("Errore gare");

        const data = await res.json().catch(() => []);
        setGare(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error(error);
        setGare([]);
        setSelectedGaraId("");
        setGiocatori([]);
        resetRisultatoAndReti();
        toast.error("Impossibile caricare le gare.");
      } finally {
        setLoadingGare(false);
      }
    };

    fetchGare();
  }, [selectedEventoId, selectedCategoria, authFetch]);

  useEffect(() => {
    const fetchConvocati = async () => {
      if (!selectedGaraId) {
        setGiocatori([]);
        return;
      }

      setLoadingGiocatori(true);
      try {
        const res = await authFetch(
          `${API_URL}/api/convocazioni/gara/${selectedGaraId}/giocatori`
        );

        if (res.status === 404) {
          setGiocatori([]);
          return;
        }

        if (!res.ok) {
          throw new Error("Errore convocati");
        }

        const data = await res.json().catch(() => []);

        const lista = Array.isArray(data)
          ? data.map((item) => ({
              idGiocatore: item?.idGiocatore ?? item?.id ?? null,
              cognome: item?.cognome ?? "",
              nome: item?.nome ?? "",
            }))
          : [];

        setGiocatori(lista.filter((g) => g.idGiocatore));
      } catch (error) {
        console.error("Errore fetch convocati risultato gara:", error);
        setGiocatori([]);
        toast.error("Impossibile caricare i convocati.");
      } finally {
        setLoadingGiocatori(false);
      }
    };

    fetchConvocati();
  }, [selectedGaraId, authFetch]);

  useEffect(() => {
    resetRisultatoAndReti();
  }, [selectedGaraId]);

  useEffect(() => {
    const fetchRisultatoEsistente = async () => {
      if (!selectedGaraId) return;

      setLoadingRisultato(true);
      try {
        const res = await authFetch(
          `${API_URL}/api/admin/risultati-gara/by-gara/${selectedGaraId}`
        );

        if (res.status === 404) {
          setRisultatoEsistenteId(null);
          setOsservazioniGara("");
          setVisibileBacheca(false);
          setReti([]);
          return;
        }

        if (!res.ok) {
          throw new Error("Errore caricamento risultato esistente");
        }

        const data = await res.json().catch(() => null);

        setRisultatoEsistenteId(data?.id ?? data?.idRisultatoGara ?? null);
        setOsservazioniGara(data?.osservazioniGara ?? "");
        setVisibileBacheca(!!data?.visibileBacheca);
      } catch (error) {
        console.error(error);
        setRisultatoEsistenteId(null);
        setOsservazioniGara("");
        setVisibileBacheca(false);
      } finally {
        setLoadingRisultato(false);
      }
    };

    fetchRisultatoEsistente();
  }, [selectedGaraId, authFetch]);

  useEffect(() => {
    const fetchReti = async () => {
      if (!risultatoEsistenteId) {
        setReti([]);
        return;
      }

      setLoadingReti(true);
      try {
        const res = await authFetch(
          `${API_URL}/api/admin/risultati-gara/${risultatoEsistenteId}/reti`
        );

        if (!res.ok) throw new Error("Errore caricamento reti");

        const data = await res.json().catch(() => []);
        setReti(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error(error);
        setReti([]);
        toast.error("Impossibile caricare le reti.");
      } finally {
        setLoadingReti(false);
      }
    };

    fetchReti();
  }, [risultatoEsistenteId, authFetch]);

  const formatDate = (value) => {
    if (!value) return "—";
    const d = new Date(`${value}T00:00:00`);
    return Number.isNaN(d.getTime()) ? value : d.toLocaleDateString("it-IT");
  };

  const formatTime = (value) => {
    if (!value) return "—";
    return value?.slice?.(0, 5) || value;
  };

  const garaLabel = (g) => {
    if (!g) return "—";
    if (g.gara) return g.gara;
    const avversario = g.avversario || "Avversario";
    return `${avversario} - ${formatDate(g.dataGara)} - ${formatTime(g.oraGara)}`;
  };

  const startEditRete = (rete) => {
    setReteInModificaId(rete.id);
    setMarcatoreSelezionato(rete.idMarcatore ?? null);
    setAssistSelezionato(rete.idAssist ?? null);
    setMinuto(rete.minuto ?? "");
    setTipoRete(rete.tipoRete || "NORMALE");
    setSquadraRete(rete.squadraRete || "MONTEROTONDO");
  };

  const handleSaveRisultato = async (isFinalSave = false) => {
    if (!selectedGaraId) {
      toast.error("Seleziona una gara.");
      return null;
    }

    const payload = {
      idGara: Number(selectedGaraId),
      goalCasa: punteggio.goalCasa,
      goalOspite: punteggio.goalOspite,
      osservazioniGara,
      visibileBacheca,
    };

    const isUpdate = !!risultatoEsistenteId;
    const url = isUpdate
      ? `${API_URL}/api/admin/risultati-gara/${risultatoEsistenteId}`
      : `${API_URL}/api/admin/risultati-gara`;

    const method = isUpdate ? "PUT" : "POST";

    setSavingRisultato(true);

    try {
      const res = await authFetch(url, {
        method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        throw new Error("Errore nel salvataggio del risultato");
      }

      const data = await res.json().catch(() => null);
      const nuovoId = getRisultatoId(data);

      let finalId = risultatoEsistenteId;

      if (nuovoId) {
        setRisultatoEsistenteId(nuovoId);
        finalId = nuovoId;
      } else if (!isUpdate) {
        const retryRes = await authFetch(
          `${API_URL}/api/admin/risultati-gara/by-gara/${selectedGaraId}`
        );

        if (retryRes.ok) {
          const retryData = await retryRes.json().catch(() => null);
          const retryId = getRisultatoId(retryData);
          setRisultatoEsistenteId(retryId);
          finalId = retryId;
        }
      }

      if (isFinalSave) {
        setGaraChiusa(true);
        toast.success("Gara registrata con successo.");
      }

      return finalId;
    } catch (error) {
      console.error(error);
      toast.error("Errore nel salvataggio del risultato.");
      return null;
    } finally {
      setSavingRisultato(false);
    }
  };

  const handleSaveRete = async () => {
    if (squadraRete === "MONTEROTONDO" && !marcatoreSelezionato) {
      toast.error("Seleziona un marcatore.");
      return;
    }

    let minutoNum = null;
    if (minuto !== "" && minuto !== null) {
      const m = Number(minuto);
      if (!Number.isInteger(m) || m < 0 || m > 130) {
        toast.error("Minuto non valido. Inserisci un valore tra 0 e 130.");
        return;
      }
      minutoNum = m;
    }

    let idRisultato = risultatoEsistenteId;

    if (!idRisultato) {
      idRisultato = await handleSaveRisultato(false);
      if (!idRisultato) return;
    }

    const payload = {
      idMarcatore:
        squadraRete === "MONTEROTONDO"
          ? Number(marcatoreSelezionato)
          : null,
      idAssist:
        squadraRete === "MONTEROTONDO" && tipoRete !== "AUTOGOL"
          ? assistSelezionato
            ? Number(assistSelezionato)
            : null
          : null,
      minuto: minutoNum,
      tipoRete,
      squadraRete,
    };

    const isUpdate = !!reteInModificaId;
    const url = isUpdate
      ? `${API_URL}/api/admin/reti/${reteInModificaId}`
      : `${API_URL}/api/admin/risultati-gara/${idRisultato}/reti`;

    const method = isUpdate ? "PUT" : "POST";

    setSavingRete(true);

    try {
      const res = await authFetch(url, {
        method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        const msg = await res.text().catch(() => "");
        throw new Error(msg || "Errore nel salvataggio della rete");
      }

      const data = await res.json().catch(() => null);

      if (data) {
        if (isUpdate) {
          setReti((prev) => prev.map((r) => (r.id === data.id ? data : r)));
          toast.success("Rete aggiornata con successo.");
        } else {
          setReti((prev) => [...prev, data]);
          toast.success("Rete aggiunta con successo.");
        }
      } else {
        const refreshRes = await authFetch(
          `${API_URL}/api/admin/risultati-gara/${idRisultato}/reti`
        );
        if (refreshRes.ok) {
          const refreshData = await refreshRes.json().catch(() => []);
          setReti(Array.isArray(refreshData) ? refreshData : []);
        }

        toast.success(
          isUpdate ? "Rete aggiornata con successo." : "Rete aggiunta con successo."
        );
      }

      resetReteForm();
    } catch (error) {
      console.error(error);
      toast.error(error.message || "Errore nel salvataggio della rete.");
    } finally {
      setSavingRete(false);
    }
  };

  const handleDeleteRete = async () => {
    if (!reteDaEliminare?.id) return;

    const idRete = reteDaEliminare.id;
    setDeletingReteId(idRete);

    try {
      const res = await authFetch(`${API_URL}/api/admin/reti/${idRete}`, {
        method: "DELETE",
      });

      if (!res.ok) {
        throw new Error("Errore eliminazione rete");
      }

      setReti((prev) => prev.filter((r) => r.id !== idRete));

      if (reteInModificaId === idRete) {
        resetReteForm();
      }

      toast.success("Rete eliminata.");
      setReteDaEliminare(null);
    } catch (error) {
      console.error(error);
      toast.error("Errore durante l'eliminazione della rete.");
    } finally {
      setDeletingReteId(null);
    }
  };

  const renderRiepilogoMarcatore = (r) => {
    if (r.squadraRete === "AVVERSARIA") {
      return `Gol ${garaSelezionata?.avversario || "avversaria"}`;
    }
    return r.marcatore || "-";
  };

  const renderRiepilogoAssist = (r) => {
    if (r.squadraRete === "AVVERSARIA") {
      return "Assist: -";
    }
    return r.assist ? `Assist: ${r.assist}` : "Assist: -";
  };

  return (
    <div className="risultato-page" translate="no">
      <div className="risultato-shell">
        <div className="risultato-header-card">
          <div>
            <span className="risultato-badge">Risultato gara</span>
            <h2>Gestione Risultato Gara</h2>
            <p>
              Seleziona evento, categoria e gara. Poi registra reti, marcatori, assist man
              e chiudi la partita con il riepilogo finale.
            </p>
          </div>
        </div>

        <div className="risultato-form-card">
          <div className="risultato-top-grid">
            <div className="risultato-field">
              <label>Evento Gara</label>
              <select
                value={selectedEventoId}
                onChange={(e) => {
                  setSelectedEventoId(e.target.value);
                  setSelectedCategoria("");
                  setSelectedGaraId("");
                  setCategorie([]);
                  setGare([]);
                  setGiocatori([]);
                  resetRisultatoAndReti();
                }}
                disabled={loadingEventi || savingRisultato}
                required
              >
                <option value="">
                  {loadingEventi ? "Caricamento eventi..." : "Seleziona evento"}
                </option>
                {eventi.map((ev) => (
                  <option key={ev.id} value={ev.id}>
                    {ev.nomeEvento}
                  </option>
                ))}
              </select>
            </div>

            {categorie.length > 1 ? (
              <div className="risultato-field">
                <label>Categoria</label>
                <select
                  value={selectedCategoria}
                  onChange={(e) => {
                    setSelectedCategoria(e.target.value);
                    setSelectedGaraId("");
                    setGare([]);
                    setGiocatori([]);
                    resetRisultatoAndReti();
                  }}
                  disabled={!selectedEventoId || loadingCategorie || savingRisultato}
                  required
                >
                  <option value="">
                    {loadingCategorie ? "Caricamento categorie..." : "Seleziona categoria"}
                  </option>
                  {categorie.map((cat) => (
                    <option key={cat.id} value={cat.id}>
                      {cat.nome}
                    </option>
                  ))}
                </select>
              </div>
            ) : categorie.length === 1 ? (
              <div className="risultato-field">
                <label>Categoria</label>
                <input type="text" value={categorie[0].nome} readOnly />
              </div>
            ) : (
              <div className="risultato-field">
                <label>Categoria</label>
                <input
                  type="text"
                  value={loadingCategorie ? "Caricamento..." : "Nessuna categoria disponibile"}
                  readOnly
                />
              </div>
            )}

            <div className="risultato-field">
              <label>Gara</label>
              <select
                value={selectedGaraId}
                onChange={(e) => setSelectedGaraId(e.target.value)}
                disabled={!selectedCategoria || loadingGare || savingRisultato}
                required
              >
                <option value="">
                  {loadingGare ? "Caricamento gare..." : "Seleziona gara"}
                </option>
                {gare.map((g, index) => {
                  const garaId = getGaraId(g);
                  return (
                    <option key={`${garaId}-${index}`} value={garaId}>
                      {garaLabel(g)}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>

          {(eventoSelezionato || garaSelezionata) && (
            <div className="risultato-context-card">
              <h3>Contesto gara</h3>

              <div className="risultato-context-grid">
                <div className="risultato-context-box">
                  <span className="risultato-context-label">Evento</span>
                  <strong>{eventoSelezionato?.nomeEvento || "—"}</strong>
                </div>

                <div className="risultato-context-box">
                  <span className="risultato-context-label">Categoria</span>
                  <strong>{categoriaSelezionataObj?.nome || categorie[0]?.nome || "—"}</strong>
                </div>

                <div className="risultato-context-box">
                  <span className="risultato-context-label">Data gara</span>
                  <strong>{formatDate(garaSelezionata?.dataGara)}</strong>
                </div>

                <div className="risultato-context-box">
                  <span className="risultato-context-label">Ora gara</span>
                  <strong>{formatTime(garaSelezionata?.oraGara)}</strong>
                </div>

                <div className="risultato-context-box">
                  <span className="risultato-context-label">Avversario</span>
                  <strong>{garaSelezionata?.avversario || "—"}</strong>
                </div>

                <div className="risultato-context-box">
                  <span className="risultato-context-label">Luogo</span>
                  <strong>{garaSelezionata?.luogo || "—"}</strong>
                </div>
              </div>
            </div>
          )}

          {selectedGaraId && (
            <div className="risultato-rete-builder-card">
              <div className="risultato-section-header">
                <div>
                  <h3>Gestione reti</h3>
                  <p>Inserisci minuto, tipo rete e registra chi ha segnato.</p>
                </div>
              </div>

              <div className="risultato-live-score-card">
                <span className="risultato-live-score-label">Risultato attuale</span>
                <div className="risultato-live-score-value">
                  <strong>{squadraCasaLabel}</strong>
                  <span>{punteggio.goalCasa}</span>
                  <span>-</span>
                  <span>{punteggio.goalOspite}</span>
                  <strong>{squadraOspiteLabel}</strong>
                </div>
              </div>

              <div className="risultato-detail-grid">
                <div className="risultato-field">
                  <label>Minuto</label>
                  <input
                    type="number"
                    min="0"
                    max="130"
                    value={minuto}
                    onChange={(e) => setMinuto(e.target.value)}
                    placeholder="Es. 23"
                  />
                </div>

                <div className="risultato-field">
                  <label>Tipo rete</label>
                  <select value={tipoRete} onChange={(e) => setTipoRete(e.target.value)}>
                    {TIPI_RETE.map((t) => (
                      <option key={t.value} value={t.value}>
                        {t.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="risultato-team-choice">
                <span className="risultato-team-choice-label">Chi ha segnato?</span>

                <div className="risultato-team-choice-actions">
                  <button
                    type="button"
                    className={`risultato-team-btn ${
                      squadraRete === "MONTEROTONDO" ? "active" : ""
                    }`}
                    onClick={() => setSquadraRete("MONTEROTONDO")}
                  >
                    Gol Monterotondo 1935
                  </button>

                  <button
                    type="button"
                    className={`risultato-team-btn ${
                      squadraRete === "AVVERSARIA" ? "active" : ""
                    }`}
                    onClick={() => setSquadraRete("AVVERSARIA")}
                  >
                    Gol {garaSelezionata?.avversario || "Avversario"}
                  </button>
                </div>
              </div>

              {tipoRete === "AUTOGOL" && squadraRete === "MONTEROTONDO" && (
                <div className="risultato-info-box">
                  Autogol selezionato: l’assist non è previsto e verrà ignorato.
                </div>
              )}

              {squadraRete === "AVVERSARIA" ? (
                <div className="risultato-info-box">
                  Gol di {nomeSquadraRete}: marcatore e assist man non sono richiesti.
                </div>
              ) : loadingGiocatori ? (
                <div className="risultato-empty-state">Caricamento convocati...</div>
              ) : giocatori.length === 0 ? (
                <div className="risultato-empty-state">
                  Nessun convocato disponibile per questa gara.
                </div>
              ) : (
                <div className="risultato-players-grid">
                  {giocatori.map((g) => {
                    const isMarcatore = marcatoreSelezionato === g.idGiocatore;
                    const isAssist = assistSelezionato === g.idGiocatore;

                    return (
                      <div
                        key={g.idGiocatore}
                        className={`risultato-player-card ${
                          isMarcatore ? "is-scorer" : ""
                        } ${isAssist ? "is-assist" : ""}`}
                      >
                        <div className="risultato-player-main">
                          <div className="risultato-player-name">
                            {g.cognome} {g.nome}
                          </div>
                        </div>

                        <div className="risultato-player-actions">
                          <button
                            type="button"
                            className={`player-role-btn ${isMarcatore ? "active" : ""}`}
                            onClick={() =>
                              setMarcatoreSelezionato(isMarcatore ? null : g.idGiocatore)
                            }
                            disabled={assistSelezionato === g.idGiocatore}
                          >
                            Marcatore
                          </button>

                          <button
                            type="button"
                            className={`player-role-btn ${isAssist ? "active" : ""}`}
                            onClick={() =>
                              setAssistSelezionato(isAssist ? null : g.idGiocatore)
                            }
                            disabled={
                              tipoRete === "AUTOGOL" ||
                              marcatoreSelezionato === g.idGiocatore
                            }
                          >
                            Assist man
                          </button>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}

              <div className="risultato-inline-actions">
                <button
                  type="button"
                  className="risultato-btn primary"
                  onClick={handleSaveRete}
                  disabled={savingRete || savingRisultato}
                >
                  {savingRete
                    ? "Salvataggio..."
                    : reteInModificaId
                    ? "Aggiorna rete"
                    : "Aggiungi rete"}
                </button>

                {reteInModificaId && (
                  <button
                    type="button"
                    className="risultato-btn ghost"
                    onClick={resetReteForm}
                  >
                    Annulla modifica
                  </button>
                )}

                <button
                  type="button"
                  className="risultato-btn ghost"
                  onClick={() => setShowFineGara((prev) => !prev)}
                >
                  {showFineGara ? "Chiudi pannello fine gara" : "Fine gara"}
                </button>
              </div>
            </div>
          )}
        </div>

        {selectedGaraId && (
          <div className="risultato-reti-list-card">
            <div className="risultato-section-header">
              <div>
                <h3>Riepilogo gara</h3>
                <p>Situazione attuale del risultato e delle reti inserite.</p>
              </div>
            </div>

            <div className="risultato-summary-card">
              <div className="risultato-summary-score">
                <strong>{squadraCasaLabel}</strong>
                <span>{punteggio.goalCasa}</span>
                <span>-</span>
                <span>{punteggio.goalOspite}</span>
                <strong>{squadraOspiteLabel}</strong>
              </div>

              <div className="risultato-summary-list">
                {reti.length === 0 ? (
                  <div className="risultato-empty-state">
                    Nessuna rete inserita al momento.
                  </div>
                ) : (
                  reti.map((r) => (
                    <div key={r.id} className="risultato-summary-row">
                      <span>{r.minuto ?? "-"}'</span>
                      <span>{renderRiepilogoMarcatore(r)}</span>
                      <span>{renderRiepilogoAssist(r)}</span>
                    </div>
                  ))
                )}
              </div>
            </div>
          </div>
        )}

        {selectedGaraId && showFineGara && (
          <div className="risultato-reti-list-card">
            <div className="risultato-section-header">
              <div>
                <h3>Fine gara</h3>
                <p>Completa le informazioni finali della partita.</p>
              </div>
            </div>

            <div className="risultato-live-score-card risultato-live-score-card--finale">
              <span className="risultato-live-score-label">Risultato finale</span>
              <div className="risultato-live-score-value">
                <strong>{squadraCasaLabel}</strong>
                <span>{punteggio.goalCasa}</span>
                <span>-</span>
                <span>{punteggio.goalOspite}</span>
                <strong>{squadraOspiteLabel}</strong>
              </div>
            </div>

            <label className="risultato-checkbox-row">
              <input
                type="checkbox"
                checked={visibileBacheca}
                onChange={(e) => setVisibileBacheca(e.target.checked)}
              />
              <span>Visibile in bacheca</span>
            </label>

            <div className="risultato-field">
              <label>Osservazioni gara</label>
              <textarea
                value={osservazioniGara}
                onChange={(e) => setOsservazioniGara(e.target.value)}
                placeholder="Inserisci eventuali note finali..."
              />
            </div>

            <div className="risultato-inline-actions">
              <button
                type="button"
                className="risultato-btn primary"
                onClick={() => handleSaveRisultato(true)}
                disabled={savingRisultato || loadingRisultato}
              >
                {savingRisultato ? "Salvataggio..." : "Salva fine gara"}
              </button>
            </div>
          </div>
        )}

        {selectedGaraId && garaChiusa && (
          <div className="risultato-reti-list-card">
            <div className="risultato-chiusura-card">
              <h3>Gara registrata</h3>
              <p>La gara è stata registrata correttamente. Puoi tornare al gestionale.</p>

              <div className="risultato-inline-actions">
                <button
                  type="button"
                  className="risultato-btn primary"
                  onClick={() => navigate("/gestionale")}
                >
                  Torna al Gestionale
                </button>
              </div>
            </div>
          </div>
        )}

        {selectedGaraId && !garaChiusa && (
          <div className="risultato-reti-list-card">
            <div className="risultato-section-header">
              <div>
                <h3>Reti inserite</h3>
                <p>{loadingReti ? "Caricamento..." : `${reti.length} elemento/i presenti.`}</p>
              </div>
            </div>

            {loadingReti ? (
              <div className="risultato-empty-state">Caricamento reti...</div>
            ) : reti.length === 0 ? (
              <div className="risultato-empty-state">
                Nessuna rete inserita al momento.
              </div>
            ) : (
              <div className="risultato-reti-grid">
                {reti.map((r) => (
                  <div key={r.id} className="rete-item-card">
                    <div className="rete-item-top">
                      <div className="rete-item-badges">
                        <span className="rete-badge">{r.tipoRete || "-"}</span>
                        <span className="rete-badge">{r.minuto ?? "-"}</span>
                        <span className="rete-badge">
                          {r.squadraRete === "AVVERSARIA"
                            ? garaSelezionata?.avversario || "Avversaria"
                            : "Monterotondo 1935"}
                        </span>
                      </div>

                      <div className="rete-item-actions">
                        <button
                          type="button"
                          className="rete-edit-btn"
                          onClick={() => startEditRete(r)}
                        >
                          Modifica
                        </button>

                        <button
                          type="button"
                          className="rete-remove-btn"
                          onClick={() => setReteDaEliminare(r)}
                          disabled={deletingReteId === r.id}
                        >
                          {deletingReteId === r.id ? "..." : "Rimuovi"}
                        </button>
                      </div>
                    </div>

                    <div className="rete-item-body">
                      <div>
                        <span className="rete-label">Marcatore</span>
                        <strong>
                          {r.squadraRete === "AVVERSARIA"
                            ? `Gol ${garaSelezionata?.avversario || "avversaria"}`
                            : (r.marcatore || "-")}
                        </strong>
                      </div>

                      <div>
                        <span className="rete-label">Assist</span>
                        <strong>
                          {r.squadraRete === "AVVERSARIA" ? "-" : (r.assist || "-")}
                        </strong>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
      </div>

      <ConfirmModal
        open={!!reteDaEliminare}
        title="Elimina rete"
        message="Vuoi eliminare questa rete?"
        confirmText="Elimina"
        cancelText="Annulla"
        danger
        onConfirm={handleDeleteRete}
        onCancel={() => setReteDaEliminare(null)}
      />
    </div>
  );
}